import { Component } from "@angular/core";
import {
  Platform,
  NavParams,
  ViewController,
  ModalController
} from "ionic-angular";
import { SummaryServiceProvider } from "../../../../providers/wh/summary-service";
import { DownloadPDFModalComponent } from "../dowload-pdf-modal/dowload-pdf-modal";
import { ChangePasswordModalComponent } from "../change-pass-modal/change-pass-modal";

@Component({
  selector: "add-sites-modal",
  templateUrl: "add-sites-modal.html",
  providers: [SummaryServiceProvider]
})
export class AddSitesModalComponent {
  data;
  cpName;
  merchantStatusList: any;
  username: any;
  firstName: any;
  lastName: any;
  status: any;
  password: any;
  sitesCount: any;
  initialView: any;
  resultView: any;
  siteInfo: any;

  constructor(
    public platform: Platform,
    public modalCtrl: ModalController,
    public params: NavParams,
    public summaryService: SummaryServiceProvider,
    public viewCtrl: ViewController
  ) {
    this.initialView = true;
    this.resultView = false;
    this.data = this.params.get("data");
  }

  compareFn(a, b) {
    return a && b ? a === b : a === b;
  }

  dismiss() {
    this.viewCtrl.dismiss(true);
  }

  createTempSites() {
    var payload: any = {
      siteNumbers: this.sitesCount,
      uid: this.data.id,
      passwordLength: 6
    };
    let userInfo = JSON.parse(localStorage.getItem("userInfoData"));
    if (userInfo && userInfo.currency == "SAR") {
      payload.areaId = "15711472905473431";
    }
    this.summaryService
      .postAddSites(`techsupport/managerusers/temporary`, payload)
      .then((res: any) => {
        this.siteInfo = res.data;
        this.initialView = false;
        this.resultView = true;
      });
  }

  changePassword(item) {
    const modal = this.modalCtrl.create(ChangePasswordModalComponent, {
      data: item
    });
    modal.onDidDismiss(data => {
      if (data) {
        this.siteInfo = this.siteInfo.map(ele => {
          if (ele.id == data.id) {
            ele.password = data.password;
          }
          return ele;
        });
      }
    });
    modal.present();
  }

  openDownloadPdfLabelModal() {
    const modal = this.modalCtrl.create(DownloadPDFModalComponent, {
      data: this.data,
      newSites: this.siteInfo
    });
    this.viewCtrl.dismiss(true);
    modal.onDidDismiss(data => {
      if (data) {
      }
    });
    modal.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/backoffice/add-sites/add-sites-modal/add-sites-modal.ts